// extracted by mini-css-extract-plugin
export default {"container":"not-allowed-screen_container__cYzOw","card":"not-allowed-screen_card__+eF2N","text":"not-allowed-screen_text__ThmoQ"};